"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hrefs = exports.browsers = exports.browserNormalizations = void 0;
const browsers = ['Chrome', 'Safari', 'Edge', 'Firefox'];
exports.browsers = browsers;
const hrefs = {
  [browsers[0]]: 'https://www.google.com/chrome/',
  [browsers[1]]: 'https://www.apple.com/safari/',
  [browsers[2]]: 'https://www.microsoft.com/windows/microsoft-edge',
  [browsers[3]]: 'https://www.mozilla.org/firefox/new/'
};
exports.hrefs = hrefs;
const browserNormalizations = {
  'Microsoft Edge': 'Edge',
  'Samsung Internet for Android': 'Samsung Internet'
};
exports.browserNormalizations = browserNormalizations;